// extracted by mini-css-extract-plugin
export default {"modal":"hv","topline":"iv","img":"jv","textcontents":"kv","heading":"lv","copy":"mv","link":"nv","close":"ov","modalinner":"pv","container":"qv"};
    if(module.hot) {
      // 1726593103463
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  